module.exports = __webpack_public_path__ + "img/erp-login-m.37adc447.png";